/**
 * Enum של תפקידים במערכת
 * 4 תפקידים: מורה, תלמיד, מורה מוביל, מנהל
 */
export const RoleType = {
  STUDENT: 'Student',
  TEACHER: 'Teacher',
  REGULAR_TEACHER:"RegularTeacher",
  LEAD_TEACHER: 'LeadTeacher',
  MANAGER: 'Manager',
};

